import { lazy } from 'react';

import RoutePaths from 'wallet-transfer/config/routes/route-paths';

const Routes = [
  {
    path: RoutePaths.preload,
    component: lazy(() => import('wallet-transfer/pages/preload-page')),
  },
  {
    path: RoutePaths.authentication,
    component: lazy(() => import('wallet-transfer/pages/authentication')),
  },
  {
    path: RoutePaths.errorNumber,
    component: lazy(() => import('wallet-transfer/pages/error-number')),
  },
  {
    path: RoutePaths.success,
    component: lazy(() => import('wallet-transfer/pages/success')),
  },
  {
    path: RoutePaths.expired,
    component: lazy(() => import('wallet-transfer/pages/expired-transaction')),
  },
  {
    path: RoutePaths.error,
    component: lazy(() => import('wallet-transfer/pages/error-page')),
  },
];

export default Routes;
